export default {
  title: 'DIY Modeler',
  subtitle: 'Simple and generic models that you can create independently, with your data and our technology.',
  createModel: 'Create Model',
  cancel: 'Cancel',
  wizardUploadHint: 'Click the button below to upload your data.',
  wizardDownloadTemplateText: 'You can download a copy of the data template',
  wizardDownloadTemplateLink: 'here',
  unsupportedFileType: 'Unsupported file type. Only .xlsx files are accepted.',
  errorUploadingFile: 'Error uploading file. Please try again.',
  uploadingFile: 'Uploading file',
  validationErrorsTitle: 'Validation Errors',
  sheetGeneral: 'General',
  errorSingular: 'error',
  errorPlural: 'errors',
  close: 'Close',
  rows: 'rows',
  andMore: 'And {count} more',
  downloadCsv: 'Export Error Details as CSV',
  priorsMarketingTitle: 'Total Marketing Attribution Range',
  priorsMarketingDescription: 'Set the expected range for the total contribution of all marketing activities to your KPI.',
  priorsMin: 'Min',
  priorsMax: 'Max',
  priorsChannelTitle: 'ROAS Range by Media',
  priorsChannelDescription: 'Enable each media channel you want to set a target ROAS range for. Disabled channels will have no restrictions.',
  priorsNoChannels: 'Upload and validate a data file to see available media channels.',
  priorsAdstockTitle: 'Fast Decay Media',
  priorsAdstockDescription: 'Select all media channels whose effects decay rapidly over time.',
  priorsNoChannelsAdstock: 'Upload and validate a data file to see available media channels.',
  priorsSaturationTitle: 'Select Constraint',
  priorsSaturationOptionAttribution: 'Total Marketing Attribution Range',
  priorsSaturationOptionRoas: 'ROAS Range by Media',
  priorsStepAttribution: 'Attribution',
  priorsStepRoas: 'ROAS',
  priorsStepAttributionRoas: 'Constraints',
  priorsStepDecay: 'Fast Decay',
  generateNameAlreadyUsed: 'This name is already in use.',
  generateNameExistsInClients: 'A client model with this name already exists.',
  errorGeneratingModel: 'Error generating model. Please try again.',
  wizardTitle: 'New Automatic Model',
  wizardStepDataUpload: 'Data Upload',
  wizardModelNameLabel: 'Model Name',
  wizardSelectFile: 'Select Data File',
  wizardReUpload: 'Re-upload File',
  wizardValidating: 'Validating your data...',
  wizardValidSuccess: 'Data validated successfully',
  wizardValidFailed: 'Validation failed',
  wizardValidationIssuesIntro: 'Your data template contains the following issues that must be resolved to continue:',
  wizardViewErrors: 'View Errors',
  wizardStepModelName: 'Model Name',
  wizardModelNameDescription: 'Choose a name for your model. This name must be unique.',
  wizardGenerateButton: 'Generate',
  wizardGenerating: 'Generating...',
  headerModelName: 'Model Name',
  headerDateCreated: 'Created',
  headerCreatedBy: 'Created By',
  headerDetails: 'Settings',
  headerStatus: 'Status',
  detailsAttribution: 'Attribution',
  detailsRoas: 'ROAS',
  detailsFastDecay: 'Fast Decay',
  detailsAttributionRange: 'Attribution range: {min}% – {max}%',
  detailsRoasChannels: 'ROAS ranges:',
  detailsFastDecayChannels: 'Fast decay channels:',
  statusPending: 'Pending',
  statusUploaded: 'Uploaded',
  statusGenerating: 'Generating Model',
  statusGenerated: 'Generated',
  statusError: 'Error',
  deleteModel: 'Delete Model',
  deleteWarningTitle: 'Delete Model',
  deleteModelMessage: 'Are you sure you want to permanently delete "{name}"? This action cannot be undone.',
  deleteModelMessageTrash: 'Are you sure you want to delete "{name}"? It can be recovered for 7 days by asking an administrator.',
  deleteModelConfirm: 'Delete',
  delete: 'Delete',
  unnamedModel: 'Unnamed Model',
  priorsMaxBelowMin: 'Max must be > Min',
  priorsValueMustBePositive: 'Must be > 0',
  priorsValueCannotBeNegative: 'Must be >= 0',
  priorsChannelMaxLimit: 'Must be <= 10',
  priorsValueOutOfRange: 'Must be between 0 and 100',
  dataFrequencyLabel: 'Data Frequency',
  dataFrequencyDescription: 'Select the frequency of your data before uploading.',
  dataFrequencyWeekly: 'Weekly',
  dataFrequencyMonthly: 'Monthly',
  downloadDataTemplate: 'Download Data Template',
  downloadAssemblerPkl: 'Download Assembler PKL',
  printConfigMap: 'Print Config Map',
  printJson: 'Print JSON',
  viewReport: 'View Report',
  highMapeWarning: 'Model accuracy may be low',
  modelNameNoteTitle: 'Note',
  modelNameNoteText: 'The Model Report charts display the last 3 years of data. Your ROAS and Attribution restrictions are enforced across your entire dataset, so values shown in the charts may fall outside your specified ranges. These differences are expected due to this approach.',
  wizardMediaChannelsDetected: 'Media channels detected',
  wizardChannelOriginalName: 'Original Name',
  wizardChannelDisplayName: 'Display Name'
}
